import { COLORS } from 'config/theme';
import styled, { css } from 'styled-components';

export const styles = {
  nestedList: {
    marginLeft: 43,
  },
  listItem: {
    height: 40,
    padding: '0 15px 0 10px',
    borderRadius: 3,
    color: COLORS.primaryColor,
    fontSize: 15,
    letterSpacing: 0.3,
    '&.is_active': {
      background: 'rgba(51, 65, 142, 0.07)',
    },
  },
  listItemButton: {
    '&:hover': {
      background: 'rgba(51, 65, 142, 0.07)',
    },
  },
  listText: {
    padding: 0,
  },
};

export const StyledSidebar = styled.div`
  transition: 0.25s all;
  transform: translateX(-100%);
  padding: 10px 10px;
  width: 0;
  min-width: 0;
  overflow: auto;

  ${props => props.isOpen && css`
    width: 288px;
    min-width: 288px;

    transform: translateX(0);
  `}
`;

export const SecondaryText = styled.span`
  margin-left: auto;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  letter-spacing: 0.4px;
  text-align: right;
`;

export const ListHeader = styled.div`
  padding: 0 15px 0 10px;
  font-size: 13px;
  line-height: 1.26;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.84);
  font-weight: 600;
`;

export const ToggleIcon = styled.div`
  display: flex;

  svg {
    transition: all 0.25s;
    transform: rotate(90deg);

    ${props => props.isOpen && css`
      transform: rotate(180deg);
    `}
  }
`;

export const ListDivider = styled.div`
  height: 1px;
  margin-left: 50px;
  background: ${COLORS.primaryLight};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Sidebar/Sidebar.styles.js